import type * as React from 'react';
import { get } from '@Domain/Api';
import costIndicatorsFetched, {
	type CostIndicatorsFetchedAction,
	type CostIndicatorsPayload,
} from '@Application/Indicators/Actions/costIndicatorsFetched';
import costIndicatorsFetchFailed, {
	type CostIndicatorsFetchFailedAction,
} from '@Application/Indicators/Actions/costIndicatorsFetchFailed';
import resolveIndicatorBasePath from '@Application/Indicators/resolveIndicatorBasePath';
import type FetchCostIndicators from '@Application/Indicators/Queries/FetchCostIndicators';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = CostIndicatorsFetchedAction | CostIndicatorsFetchFailedAction;

type CostIndicatorsResponse = Omit<CostIndicatorsPayload, 'queryKey'>;

export default (query: FetchCostIndicators) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<CostIndicatorsResponse>(
				`${resolveIndicatorBasePath(query.scope)}/ai-costs?${query.toQueryString()}`,
			);

			const action = costIndicatorsFetched({ ...response, queryKey: query.queryKey });
			dispatch(action);
			return action;
		} catch (error) {
			const action = costIndicatorsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
